module.exports = __webpack_public_path__ + "img/milestone-mid.40e3977e.png";